export default {
    browser_title: "Kevi | UTM Automático",
    page_title: "UTM Automático",
    page_description:
        "Configure parâmetros UTM para serem automaticamente adicionados aos links nas notificações",
    success_message: "Atualizado com sucesso",
    error_save: "Erro ao salvar",
    error_save_config: "Erro ao salvar as configurações",
    token_copied: "Token copiado com sucesso!",
    toggle: {
        label: "Ativar UTM Automático",
        hint: "Quando ativado, os parâmetros UTM serão automaticamente adicionados ou substituídos em todos os links encontrados nas notificações.",
    },
    channels: {
        title: "Canais",
        description:
            "Selecione em quais canais o UTM automático será aplicado:",
        email: "E-mail",
        sms: "SMS",
        rcs: "RCS",
        whatsapp: "WhatsApp",
        whatsapp_cloud: "WhatsApp Cloud",
    },
    tokens: {
        title: "Tokens Disponíveis",
        description:
            "Use estes tokens nos campos abaixo para personalizar os valores UTM:",
        copy: "Copiar",
    },
    params: {
        title: "Parâmetros UTM",
        description:
            "Configure os valores para cada parâmetro UTM. Use os tokens acima para personalização.",
        source: {
            label: "UTM Source",
            hint: "Identifica a origem do tráfego",
            placeholder: "Ex: [[nome_automacao]]",
        },
        medium: {
            label: "UTM Medium",
            hint: "Identifica o meio de comunicação",
            placeholder: "Ex: [[canal]]",
        },
        campaign: {
            label: "UTM Campaign",
            hint: "Identifica a campanha específica",
            placeholder: "Ex: [[nome_automacao]] - [[data]]",
        },
    },
    info: {
        important: "Importante:",
        description:
            "Se um link já contiver parâmetros UTM (utm_source, utm_medium, utm_campaign), eles serão substituídos pelos valores configurados aqui.",
    },
    actions: {
        save: "Salvar Configurações",
    },
};
